














import { Component, Vue } from "vue-property-decorator";
import LayoutHeader from "./components/header.vue";
import LayoutFooter from "./components/footer.vue";
import { AlertMask } from "@/components";
import ConfigModule from "@/store/modules/config";

@Component({
  components: {
    LayoutHeader,
    LayoutFooter,
    AlertMask
  }
})
export default class Layout extends Vue {
  get langLoading () {
    return ConfigModule.langLoading;
  }
}

